import { UnitPrefix, BaseUnits } from "uom";
// Electric current
export var MilliAmpere = UnitPrefix.Milli("MilliAmpere", BaseUnits.Ampere);
//# sourceMappingURL=electric-current.js.map